exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addapp[data-v-36afb8f0]{padding-top:20px;padding-right:20px}.addapp .btn[data-v-36afb8f0]{width:100%;text-align:center}\n", ""]);

// exports
